<div class="chat-message chat-message-sent row" *ngIf="isCurrentUserSender()">
  <div class="col-md-12 text-right">
    <span class="chat-text">
      {{chatMessage.text}}
    </span>
    <span class="sent-date">{{chatMessage.createdDate | date:'short'}}</span>
  </div>
</div>

<div class="chat-message chat-message-received row" *ngIf="!isCurrentUserSender()">
  <div class="col-md-11 text-left">
    <span class="chat-text">
      {{chatMessage.text}}
    </span>
    <span class="sent-date">{{chatMessage.createdDate | date:'short'}}</span>
  </div>
</div>
